import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "../ScrollTrigger.js";
import { MotionPathPlugin } from "../MotionPathPlugin.js";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);



class  Tree extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)

    this.ref = {

    }
  }


  mount() {

       // CustomWiggle.create("myWiggle", {wiggles:50, type: 'uniform'});


       let mm = gsap.matchMedia();

       mm.add("(min-width: 768px)", () => {
          gsap.fromTo('.rb, .lb', {
              opacity: 0,
              scaleX: .7,
              scaleY: .7,
          }, {

              scaleX: 1,
              scaleY: 1,

              opacity: 1,
              ease: "ease",
              duration: "random(.5, 1.5)",
              scrollTrigger: {
                  trigger: ".tree__impact",
                  start: "top bottom-=10%"

              }
          })

          gsap.fromTo('.ab', {
              opacity: 0,
              scaleX: .7,
              scaleY: .7,
          }, {

              scaleX: 1,
              scaleY: 1,

              opacity: 1,
              ease: "ease",
              duration: "random(.5, 1.5)",
              scrollTrigger: {
                  trigger: ".tree__relations",
                  start: "top bottom-=10%"

              }
          })

          gsap.fromTo('.cb', {
              opacity: 0,
              scaleX: .7,
              scaleY: .7,
          }, {

              scaleX: 1,
              scaleY: 1,

              opacity: 1,
              ease: "ease",
              duration: "random(.5, 1.5)",
              scrollTrigger: {
                  trigger: ".tree__self",
                  start: "top bottom-=10%"

              }
          })

          gsap.to('.textfly', {


              opacity: 1,
              ease: "ease",
              duration: "random(.5, 1.5)",
              scrollTrigger: {
                  trigger: ".tree__impact",
                  start: "top bottom-=10%"

              }
          })
       });

       mm.add("(max-width: 767px)", () => {
           gsap.to('.textfly', {


               opacity: 1,
               ease: "ease",
               duration: "random(.5, 1.5)",
               scrollTrigger: {
                   trigger: ".tree__impact",
                   start: "top bottom-=10%"

               }
           })
       });


        

        

        

        _each($('.textfly'), (el, index) => {
            

            gsap.to(el, {
                duration:30,
                ease: 'linear',
                repeat: -1,
                motionPath: {
                    path: "#motionpath",
                    align: "#motionpath",
                    autoRotate: false,
                    start: index*0.1,
                    end: 1 + index * 0.1,
                    alignOrigin: [0.5, 0.5]
                }
            });
        })


       
    
        
    

  }

  unmount() {
    


  }

}

module.exports = Tree
